import { render, staticRenderFns } from "./FoliosParticipacion.vue?vue&type=template&id=17a753a2&scoped=true&"
import script from "./FoliosParticipacion.vue?vue&type=script&lang=js&"
export * from "./FoliosParticipacion.vue?vue&type=script&lang=js&"
import style0 from "./FoliosParticipacion.vue?vue&type=style&index=0&id=17a753a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a753a2",
  null
  
)

export default component.exports